/**
 * Prep pbjs que
 */

window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];

require('./prebid.js');
module.exports = window.pbjs;


// WEBPACK FOOTER //
// ./theroot/root-100-2019/bulbs-public-ads-manager/src/prebid-load.js